<template>
  <div>
    <div class="decision-aid" :class="{ mobile: device === 'mobile' }">
      <div class="backdrop" @click="$emit('close')"></div>
      <div class="decision-body">
        <div class="header" v-if="type === 'motorconfig_pressure'">
          <span class="title">{{ $t('motor.decisionAid.workPressureTitle') }} <span>({{ forceType }})</span></span>
          <span class="close" @click="$emit('close')">&times;</span>
        </div>
        <div class="header" v-if="type === 'motorconfig_lpm'">
          <span class="title">{{ $t('motor.decisionAid.oilFlowTitle') }}</span>
          <span class="close" @click="$emit('close')">&times;</span>
        </div>
        <div class="header" v-if="type === 'motorconfig_power'">
          <span class="title">{{ $t('motor.decisionAid.ccTitle') }}</span>
          <span class="close" @click="$emit('close')">&times;</span>
        </div>

        <table>
          <thead>
          <tr v-if="type === 'motorconfig_pressure'">
            <th>CC/Bar</th>
            <th v-for="(val) in aidHeaderPressure" v-text="val + ' bar'"></th>
          </tr>
          <tr v-if="type === 'motorconfig_lpm'">
            <th>{{ $t('motor.decisionAid.ccpm') }}</th>
            <th v-for="(val) in aidHeaderLpm" v-text="val + ' L/min'"></th>
          </tr>
          <tr v-if="type === 'motorconfig_power'">
            <th>{{ $t('motor.decisionAid.decisionAidCc') }}</th>
            <th v-text="$t('motor.decisionAid.force') + ' ' + this.forceType + ' @ ' + motorPreferences.pressure + ' Bar'"></th>
            <th v-text="'RPM @ ' + motorPreferences.lpm + ' L/min'"></th>
          </tr>
          </thead>

          <tbody v-if="type === 'motorconfig_pressure'">
          <tr v-for="(row, rowIndex) in aidRowsPressure">
            <td v-for="value in row" v-text="value + ' cc'" class="cursor"></td>
            <td v-for="val in aidHeaderPressure" @click="setCalcValue(val, row.cc)">{{ getTorqueCalculation(val, row.cc, true) }}</td>
          </tr>
          </tbody>
          <tbody v-if="type === 'motorconfig_lpm'">
          <tr v-for="(row, rowIndex) in aidRowsPressure">
            <td v-for="value in row" v-text="value + ' cc'" class="cursor"></td>
            <td v-for="val in aidHeaderLpm" @click="setCalcValue(val, row.cc)">{{ getRpmCalculation(val, row.cc, false) }}</td>
          </tr>
          </tbody>
          <tbody v-if="type === 'motorconfig_power'">
          <tr v-for="(row, rowIndex) in aidRowsPressure" @click="setCalcValue(row.cc)">
            <td v-for="value in row" v-text="value + ' cc'" class="cursor"></td>
            <td v-for="value in row">{{ getTorqueCalculation(motorPreferences.pressure, row.cc, true) }}</td>
            <td v-for="value in row">{{ getRpmCalculation(motorPreferences.lpm, row.cc, false) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getBoreArea, getRodArea, getAreaSpeed, getForce, round } from '@/helpers/calculations';
import { getRpmCalculation, getTorqueCalculation } from '@/helpers/motorCalculations';

export default {
  name: 'DecisionAid',

  props: {
    type: {
      type: String,
      default: '',
    },
    subtype: {
      type: String,
      default: '',
    },
    tab: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      power: 1,
      newton: 101.9716213,
      aidHeaderPressure: [50, 100, 150, 200, 250],
      aidHeaderLpm: [1, 3, 5, 10, 25, 50, 100],
      aidRowsPressure: [
        {
          cc: 8,
        },
        {
          cc: 12.5,
        },
        {
          cc: 20,
        },
        {
          cc: 25,
        },
        {
          cc: 32,
        },
        {
          cc: 40,
        },
        {
          cc: 50,
        },
        {
          cc: 80,
        },
        {
          cc: 125,
        },
        {
          cc: 160,
        },
        {
          cc: 200,
        },
        {
          cc: 250,
        },
        {
          cc: 315,
        },
        {
          cc: 400,
        },
        {
          cc: 470,
        },
        {
          cc: 500,
        },
        {
          cc: 535,
        },
        {
          cc: 630,
        },
        {
          cc: 725,
        },
        {
          cc: 800,
        },
      ],
    };
  },

  methods: {
    setCalcValue(headerValue, rowValue) {
      if (this.type === 'motorconfig_pressure') {
        this.$store.commit('build/motorConfig/setPressure', headerValue);
        this.$store.commit('build/motorConfig/setCc', rowValue);
      } else if (this.type === 'motorconfig_lpm') {
        this.$store.commit('build/motorConfig/setLpm', headerValue);
        this.$store.commit('build/motorConfig/setCc', rowValue);
      } else {
        this.$store.commit('build/motorConfig/setCc', headerValue);
      }
      this.$emit('close');
    },
    getRpmCalculation,
    getTorqueCalculation,
  },

  computed: {
    ...mapGetters({
      motorPreferences: 'build/motorConfig/getMotorPreferences',
      device: 'getDevice',
    }),

    forceType() {
      if (this.motorPreferences.unit === 'newton') {
        return this.$t('motor.settings.newton');
      } else if (this.motorPreferences.unit === 'kilogram') {
        return this.$t('motor.settings.kilogram');
      }
    },
  },

  created() {
    this.power = this.tab;
  },
};
</script>

<style scoped lang="scss">

.decision-aid {
  position: relative;
  display: flex;
  justify-content: center;

  &.mobile {
    .backdrop {
      z-index: 100;
    }

    .decision-body {
      left: 0;
      width: 100%;
      padding: 0 16px;
      z-index: 101;

      .header {
        flex-direction: column;
        padding: 10px 0 0 0;

        .radio-container {
          margin-left: 0;
          margin-top: 2px;
        }

        .close {
          right: 0;
          top: 10px;
        }
      }

      table {
        overflow: auto;
        width: 100%;
        display: block;
      }

      td {
        padding: 8px 8px;

        &.cursor {
          white-space: nowrap;
        }
      }
    }
  }

  .backdrop {
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .decision-body {
    background-color: white;
    z-index: 10;
    display: flex;
    position: absolute;
    flex-direction: column;
    width: 700px;

    .header {
      padding: 14px 19px 20px;
      height: 88px;
      display: flex;
      flex-direction: row;
      align-items: center;
      align-content: center;
      position: relative;

      .title {
        font-size: 20px;
        font-family: neue-haas-grotesk-display, sans-serif;
        font-weight: 700;
      }

      .close {
        font-size: 30px;
        transition: all ease 0.3s;
        position: absolute;
        right: 31px;
        top: 26px;
        color: #A4AFB7;
        opacity: 1;
        text-shadow: none;
        font-weight: 100;

        &:hover {
          cursor: pointer;
          color: darken(#A4AFB7, 30%);
        }

      }

      .radio-container {
        margin-right: auto;
        margin-left: 20px;
        width: 265px;
        border-radius: 50px;
        border: 2px solid #EBEBEB;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        background-color: white;
        transition: all ease 0.3s;

        label {
          cursor: pointer;
          display: flex;
          justify-content: center;
          font-size: 12px;
          margin: 0;
          border-radius: 25px;
          width: 50%;
          padding: 7px;
          user-select: none;
          font-family: neue-haas-grotesk-display, sans-serif;
        }

        input[type="radio"] {
          display: none;


          &:checked + label {
            background-color: #3DB0C7;
            color: white;
          }
        }
      }
    }

    table {
      margin-top: 10px;
      border-collapse: separate;
      border-spacing: 3px 0;
      background-color: #F0F0F0;

      th, td {
        &:nth-child(1) {
          border-collapse: unset;
          border-spacing: unset;
          border-right: #AFAFAF 4px solid;
        }
      }

      th {
        text-align: center;
        background-color: white;
        font-size: 12px;
        font-family: neue-haas-grotesk-display, sans-serif;
        font-weight: 700;
        cursor: default;
      }

      td {
        font-size: 12px;
        border-spacing: 4px;
        padding: 8px 10px;
        text-align: center;

        &:hover {
          color: white;
          background-color: rgba(61, 176, 199, 0.5);
        }
      }

      tr {
        cursor: pointer;

        &:nth-child(even) {
          background-color: white;

          &:hover {
            background-color: rgba(61, 176, 199, 0.25);

            > td:nth-child(1), td:nth-child(1) {
              color: white;
              background-color: rgba(61, 176, 199, 0.5);
            }
          }
        }

        &:nth-child(odd) {
          background-color: #EBEBEB;

          &:hover {
            background-color: rgba(61, 176, 199, 0.25);

            > td:nth-child(1), td:nth-child(1) {
              color: white;
              background-color: rgba(61, 176, 199, 0.5);
            }
          }
        }

        .selected {
          background-color: #3DB0C7;
        }
      }
    }
  }
}
</style>
